import React, { useState } from "react";
import "./styles.css";

import { useRef } from "react";
import Header from "../../Common/Header";
import Footer from "../../Common/Footer";

import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import axios from "axios";
import { ApiContext } from "../../Context/Context";
import { use, useContext, useEffect } from "react";
import {
  getRecords,
  PostRecords,
  uploadMultipleFiles,
} from "../../Services/ApiCall";
import FeaturedProperty from "../../Common/FeaturedProperties";
import ProjectsComp from "../../Common/Projects";
import NearByProperties from "../../Common/NearByProperties";
import {
  LoggedInUserID,
  LoggedInUserName,
  AUTH_KEY,
  BaseUrl,
  apiUrl_dialerp,
  setLogindata,
  setUserdata,
} from "../../Services/Urls";
import FilterParams from "../../Classes/FilterParams";
import { useNavigate } from "react-router-dom";

import { TailSpin } from "react-loader-spinner";
import SelectDialog from "../../Common/SelectDialog ";
import AmenitiesDialog from "../../Common/AmenitiesDialog";
import { decryptOtp } from "../../Services/Helper";
import {
  callApi,
  makeApiRequest,
  callAzureOpenAI,
} from "../../Services/ApiService";

import { toast } from "react-toastify";
import SucessDialog from "../../Common/Dialog/SucessDialog";
import {
  formatIndianAmount,
  removeSpecialCharacters,
} from "../../Services/Helper";


const dailyData = [
  { day: "Mon", imp: 850, views: 187, leads: 12 },
  { day: "Tue", imp: 920, views: 202, leads: 15 },
  { day: "Wed", imp: 780, views: 171, leads: 11 },
  { day: "Thu", imp: 1050, views: 231, leads: 18 },
  { day: "Fri", imp: 890, views: 195, leads: 13 },
  { day: "Sat", imp: 1120, views: 246, leads: 14 },
  { day: "Sun", imp: 425, views: 96, leads: 6 },
];

const maxImp = Math.max(...dailyData.map((d) => d.imp));

export default function AdsReport() {
  const {
    logindata,
    setlogindata,
    userData,
    setuserData,
    CityData,

    coordinates,

    Locality,

    Area,
  } = useContext(ApiContext);

  const navigate = useNavigate();
  const [DailyData, setDailyData] = useState([]);
  const [TotalImpressions, setTotalImpressions] = useState(0);
  const [TotalLeads, setTotalLeads] = useState(0);
  const [TotalViews, setTotalViews] = useState(0);
  const [TotalSpent, setTotalSpent] = useState(0.0);

  useEffect(() => {
    getCampaignsData();
  }, []);
  const getCampaignsData = () => {
    const filter = `{UserID: { $in: [${userData?.UserID}] }}`;
    getRecords(431, 1000, filter, 1, "", (data) => {
      if (data != null) {
        if (data?.hasErrors === false) {
          //  setcampaigns(data?.response?.records || []);

          if (data?.response?.records?.length > 0) {
            let Active = 0;
            let TotalImpressions = 0;
            let TotalLeads = 0;
            let TotalViews = 0;
            let TotalSpent = 0;

            data?.response?.records?.forEach((element) => {
              TotalImpressions += element?.TotalImpressions || 0;
              TotalLeads += element?.TotalLeads || 0;
              TotalViews += element?.TotalViews || 0;
              TotalSpent += Number(element?.SpentAmount || 0);
            });
            //  setActive(data?.response?.records?.length);
            setTotalImpressions(TotalImpressions);
            setTotalLeads(TotalLeads);
            setTotalViews(TotalViews);
            setTotalSpent(Number(TotalSpent.toFixed(2)));
          }
        } else {
          console.log("Error in fetching featured properties", data);
        }
      }
    });
  };

  const getDailyStats = () => {
      const filter = `'ListingID':{\$in:[$listingIds]}`;
    getRecords(431, 1000, filter, 1, "", (data) => {
      if (data != null) {
        if (data?.hasErrors === false) {
          //  setcampaigns(data?.response?.records || []);

          if (data?.response?.records?.length > 0) {
            let Active = 0;
            let TotalImpressions = 0;
            let TotalLeads = 0;
            let TotalViews = 0;
            let TotalSpent = 0;

            data?.response?.records?.forEach((element) => {
              TotalImpressions += element?.TotalImpressions || 0;
              TotalLeads += element?.TotalLeads || 0;
              TotalViews += element?.TotalViews || 0;
              TotalSpent += Number(element?.SpentAmount || 0);
            });
            //  setActive(data?.response?.records?.length);
            setTotalImpressions(TotalImpressions);
            setTotalLeads(TotalLeads);
            setTotalViews(TotalViews);
            setTotalSpent(Number(TotalSpent.toFixed(2)));
          }
        } else {
          console.log("Error in fetching featured properties", data);
        }
      }
    });


  };

  const stats = [
  { title: "Total Spend", value: `₹${TotalSpent}`, icon: "ri-money-rupee-circle-line" },
  {
    title: "Impressions",
    value: TotalImpressions,
    sub: "Shown to buyers",
    icon: "ri-eye-line",
  },
  {
    title: "Views",
    value: TotalViews,
    sub: "Opened property",
    icon: "ri-file-list-3-line",
  },
  {
    title: "Leads",
    value: TotalLeads,
    sub: "Initiated chat",
    icon: "ri-user-add-line",
  },
  {
    title: "Cost/Lead",
    value: "₹94.94",
    sub: "Avg cost per lead",
    icon: "ri-calculator-line",
  },
];

  return (
    <>
      <div className="breadcrumb">
        <span className="light">LandPanda Ads</span>
        <span className="arrow">›</span>
        <span className="bold">Ads Reports</span>
      </div>

      <div className="adsreport">
        <div className="container">
          {/* Header */}
          <div className="header">
            <h2>Performance Overview</h2>
            <div className="tabs">
              <button className="active">7 Days</button>
              <button>30 Days</button>
              <button>90 Days</button>
            </div>
          </div>

          {/* Stats */}
          <div className="stats">
            {stats.map((item, i) => (
              <div className="card" key={i}>
                <div className="icon">
                  <i class={item.icon}></i>
                </div>
                <h3 style={{marginTop:10}}>{item.value}</h3>
                <p>{item.title}</p>
                {item.sub && <span>{item.sub}</span>}
              </div>
            ))}
          </div>

          {/* Funnel */}
          <div className="funnel-card">
            <h2>Conversion Funnel</h2>
            {/* Impressions */}
            <div className="funnel-block">
              <div className="top">
                <div className="left">
                  <div className="icon blue">
                    <i class="ri-eye-line text-blue-600 text-sm sm:text-base"></i>
                  </div>
                  <div>
                    <h4>Impressions</h4>
                    <p>Property shown to buyers</p>
                  </div>
                </div>

                <div className="right">
                  <h4>{TotalImpressions}</h4>
                  <span>100%</span>
                </div>
              </div>

              <div className="progress full blue"></div>
            </div>

            <div className="arrow">↓</div>

            {/* Views */}
            <div className="funnel-block">
              <div className="top">
                <div className="left">
                  <div className="icon green">
                    <i class="ri-file-list-3-line text-emerald-600 text-sm sm:text-base"></i>
                  </div>
                  <div>
                    <h4>Views</h4>
                    <p>Buyers opened property</p>
                  </div>
                </div>

                <div className="right">
                  <h4>{TotalViews}</h4>
                  <span>22.0%</span>
                </div>
              </div>

              <div className="progress-bg">
                <div className="progress green" style={{ width: "22%" }}></div>
              </div>
            </div>

            <div className="arrow">↓</div>

            {/* Leads */}
            <div className="funnel-block">
              <div className="top">
                <div className="left">
                  <div className="icon orange">
                    <i class="ri-user-add-line text-amber-600 text-sm sm:text-base"></i>
                  </div>
                  <div>
                    <h4>Leads</h4>
                    <p>Buyers initiated chat</p>
                  </div>
                </div>

                <div className="right">
                  <h4>{TotalLeads}</h4>
                  <span>6.7%</span>
                </div>
              </div>

              <div className="progress-bg light">
                <div
                  className="progress orange"
                  style={{ width: "6.7%" }}
                ></div>
              </div>
            </div>

            {/* Note */}
            <div className="note">
              <div className="info-icon">i</div>
              <p>
                Overall: Out of every 100 impressions, ~22.0 buyers view your
                property, and ~1.5 become leads.
              </p>
            </div>
          </div>

          {/* Daily Performance */}
          <div className="card section">
            <h3>Daily Performance</h3>

            {dailyData.map((d, i) => {
              const impWidth = (d.imp / maxImp) * 100;
              const viewWidth = (d.views / d.imp) * impWidth;

              return (
                <div className="day-row" key={i}>
                  <div className="day">{d.day}</div>

                  <div className="bar-wrap">
                    <div
                      className="bar imp"
                      style={{ width: `${impWidth}%` }}
                    ></div>
                    <div
                      className="bar views"
                      style={{ width: `${viewWidth}%` }}
                    ></div>
                    <div className="lead-dot"></div>
                  </div>

                  <div className="values">
                    <span className="imp-t">{d.imp}</span>
                    <span className="view-t">{d.views}</span>
                    <span className="lead-t">{d.leads}</span>
                  </div>
                </div>
              );
            })}

            <div className="legend">
              <span>
                <i className="imp"></i> Impressions
              </span>
              <span>
                <i className="views"></i> Views
              </span>
              <span>
                <i className="leads"></i> Leads
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
